import React, { useEffect, useState } from "react";
import { ArrowRight, Menu, X } from "lucide-react";
import { company } from "../mock";

const navLinks = [
  { label: "Practice", href: "#services" },
  { label: "How We Work", href: "#process" },
  { label: "Fees", href: "#pricing" },
  { label: "Firm", href: "#about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "backdrop-blur-md bg-[#e8ecdf]/85 border-b border-[#cfd7bf]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="font-serif-display text-[1.05rem] md:text-[1.15rem] tracking-tight text-[#2a3325]">
          {company.shortName} <span className="italic-accent">{company.suffix}</span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} className="text-sm text-[#2a3325] link-underline">
              {l.label}
            </a>
          ))}
        </nav>

        <a href="#contact" className="hidden md:inline-flex btn-dark">
          Book Consultation <ArrowRight className="w-4 h-4" />
        </a>

        <button className="md:hidden text-[#2a3325]" onClick={() => setOpen((v) => !v)} aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#e8ecdf] border-t border-[#cfd7bf] px-6 py-6">
          <div className="flex flex-col gap-4">
            {navLinks.map((l) => (
              <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="text-[#2a3325]">
                {l.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="btn-dark w-fit">
              Book Consultation <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
